<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_1)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>  
              <!-- <div v-html="formattedDescriptionNo(item.description_no_2)" class="description_no"></div> -->
              <div v-html="formattedDescription(item.description_2)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_2" alt="Content Image" class="image" />
              </div>  
            </div>
          </div>
        </div>
      </div>
  </div>
      <!-- Contact Section (moved to the right) -->
      <!-- <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: +86 19883038871</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
      </div> -->
    </div>

</template>

<style src="@/assets/css/news.css" scoped></style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/News/003/XiangShanPageimg1.jpg"),
            image_2: require("@/assets/img/News/003/XiangShanPageimg2.jpg"),
            title: "云翰虹章与象山影视城达成战略合作，共同推进数字化文旅发展",
            description_1:`
            2022年11月，云翰虹章与象山影视城正式达成战略合作关系，共同推进数字化文旅的发展。

            作为中国十大影视城之一，象山影视城自2005年开城以来，已经拍摄了1500余部影视作品，其中包括《神雕侠侣》《琅琊榜》《庆余年》等知名影视剧。随着科技的进步，数字化技术逐渐在各行各业得到广泛应用，数字化文旅也成为文旅领域未来发展炙手可热的新方向。早在2020年，象山影视城就引入了大型LED设备，为数字化拍摄做好了准备。作为此次合作的技术支持者，云翰虹章在虚拟拍摄和数字特效等领域拥有丰富的经验。我们致力于将先进技术与文化旅游行业相结合，打造沉浸式的文旅体验。
`,
            description_2: `虚拟制片技术是一种利用计算机图形学、虚拟现实和增强现实等技术手段，在虚拟环境中进行影视拍摄与制作的技术。它能够在拍摄前对场景、角色、灯光等进行精确的模拟与预演，帮助导演和摄影师更好地把握拍摄效果，提高拍摄效率与质量。同时，虚拟制片技术还能够实现场景的无缝切换与特效的实时渲染，为观众带来更加震撼的视觉效果。作为虚拟制片行业的先行者，我们在虚拟制片技术领域取得了多项创新与突破。例如，我们搭建了一套高效且易于操作的虚拟制片系统，能够实现对场景、角色、灯光等元素的精确控制与调整。
            
            未来，双方将继续深化合作，携手推动数字化文旅的发展，共同探索和创造更加丰富多彩的数字化文旅体验。此次合作不仅加速了象山影视城的数字化转型进程，提升了其竞争力，也为云翰虹章开创了新的发展道路，标志着双方在数字化文旅领域迈出了关键的一步。
            `,
          description_no_1:`
          `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/News/003/XiangShanPageimg1.jpg"),
            image_2: require("@/assets/img/News/003/XiangShanPageimg2.jpg"),
            description_no_1:`
            `,
            title:
              "Rosy Nebula and Xiangshan Global Studios reached a strategic cooperation",
            description_1:`
              In November 2022, in order to promote the development of digital cultural tourism, Rosy Nebula established a cooperative relationship with Xiangshan Global Studios.

              As one of China's biggest film and television citys,  Xiangshan Global Studios has taken more than 1500 film and television works, including famous works like "The Return of the Condor Heroes", "Nirvana in Fire", and "Joy of Life" since 2005. With the development of science, digital cultural tourism may become a new direction in tourism. In 2020, Xiangshan Global Studios found the importance of digital cultural tourism, so they introduced LED equipment to prepare for some film works.

              As the technical backer of this activity, Rosy Nebula has sufficient experience in virtual shooting and digital visual effects. We are also committed to combining advanced technology with the cultural tourism industry, to create an excellent experience.
               `,
            description_2: `
              Virtual production technology is a method of using computer graphics, virtual reality, augmented reality, and other technological means to conduct film shooting and production in a virtual environment. By simulating the scenes, characters and light, it can help directors and photographers to make shoots high-quality and high-efficiency.At the same time, virtual production technology can also achieve seamless switching of scenes and real-time rendering of special effects, bringing more shocking visual effects to the audience. As a pioneer in the virtual production industry, we have achieved many innovations and breakthroughs in virtual production technology. For example, we have built a highly efficient and easy-to-operate virtual production system that can precisely control and adjust elements such as scenes, characters, and lights.
              
              In the future, the two sides will continue to deepen cooperation, work together to promote the development of digital cultural tourism, and jointly explore and create more colorful digital cultural tourism experiences. This cooperation not only accelerates the digital transformation process of Xiangshan Global Studios and enhances its competitiveness, but also opens up new development paths for Rosy Nebula, marking a key step forward for both sides in the field of digital cultural tourism.
            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>